import { SecShape, type SecondaryDef } from '../../sim/secondary';

/** S04 — MINES ASCENDANTES. La seule arme dont l'effet est DIFFÉRÉ.
 *
 *  ── Le besoin ────────────────────────────────────────────────────────────
 *  Les trois autres secondaires répondent à ce que le joueur voit. Celle-ci
 *  répond à ce qu'il SAIT : les vagues arrivent par le haut, à des instants
 *  écrits dans le niveau, et le joueur qui a joué le monde 1 trois fois les
 *  anticipe. Poser un champ de mines dix secondes avant une vague, c'est
 *  convertir de la connaissance du jeu en avantage — la récompense la plus
 *  saine qu'un shmup puisse offrir, parce qu'elle ne s'achète pas.
 *
 *  Concrètement elle résout le problème du POPCORN : les petits ennemis qui
 *  remplissent les creux du rythme meurent en un coup et ne méritent pas qu'on
 *  détourne le tir principal pour eux. Les mines les traitent gratuitement,
 *  pendant que la primaire reste sur les cibles qui comptent.
 *
 *  ── Pourquoi elles MONTENT ───────────────────────────────────────────────
 *  Une mine strictement immobile ne quitterait jamais le terrain, donc ne
 *  serait jamais recyclée par `motionSystem` : c'est une fuite de pool
 *  déguisée en effet de jeu, et elle ne se verrait qu'après vingt minutes de
 *  partie. À 90 u/s, une mine traverse le terrain en 12 s puis disparaît d'elle
 *  même — assez lent pour se lire comme un champ posé, assez rapide pour aller
 *  à la rencontre de la vague au lieu de l'attendre.
 *
 *  Vingt fois plus lente que la primaire : la hiérarchie de lecture reste
 *  intacte, on ne confond jamais une mine avec un tir.
 *
 *  ── Le compromis assumé ──────────────────────────────────────────────────
 *  107 DPS théoriques, mais réalisés seulement si la vague passe dessus. Mal
 *  jouée, cette arme ne fait rien du tout. C'est la seule du catalogue dont la
 *  valeur dépend entièrement de la décision du joueur, et c'est pourquoi elle a
 *  le plus gros dégât unitaire : la récompense doit être à la hauteur du pari. */
const mines: SecondaryDef = {
  id: 'mines-ascendantes',
  name: 'Mines ascendantes',
  shape: SecShape.Mine,
  cooldown: 6,
  shots: 1,
  shotEvery: 0,
  count: 4,
  // Largeur TOTALE du dépôt : 240 u sur 900 de terrain, soit un peu plus du
  // quart. Le champ couvre un couloir et demi — il interdit une zone, il ne
  // nettoie pas l'écran, sinon il n'y aurait plus rien à décider.
  spacing: 240,
  spreadDeg: 0,
  speed: 90,
  // Gros rayon : une mine doit être VUE et doit toucher sans exiger de
  // précision. Sa valeur est dans le placement, pas dans la visée.
  radius: 34,
  damage: 160,
  text: '4 mines × 160 dégâts, montée lente — 6 s',
};

export default mines;
